import React from "react"
import {
  ActionType,
  BrandLogoBlock,
  NavTab,
  SideNavFrame,
  useSideNavCollapse,
} from "../side-nav"

// Side navigation glyphs from the design system (currentColor).
import { ReactComponent as SurveyIcon } from "assets/svg/side-nav/survey.svg"
import PadeLogoWhite from "assets/logos/paidhr-logo-white.svg"
import {
} from "@heroicons/react/24/outline"

import { Squares2X2Icon } from "@heroicons/react/24/solid"
import { useAuthStore } from "stores"
import { isPadeDomain } from "utils/utils"
import { useCustomizationSettingsStore } from "stores/customization-settings"

export const SideNavigationBar: React.FC<{
  isSidebarOpen: boolean
  toggleSidebar: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ isSidebarOpen, toggleSidebar }) => {
  const { compact } = useSideNavCollapse()
  const { user } = useAuthStore()
  const { customizationSettings } = useCustomizationSettingsStore()

  const actions: ActionType[] = [
    {
      title: "Surveys",
      icon: <SurveyIcon className="w-4" />,
      route: "survey",
      patterns: [{ path: "/employee/dashboard/survey/*" }],
      enabled: true,
      // enabled: false,
      badge: false,
    },
  ]

  const handleToggleSidebar = () => {
    toggleSidebar(false)
    document.body.classList.remove("overflow-hidden")
  }

  return (
    <>
      {isSidebarOpen && (
        <div
          className="md:hidden fixed inset-0 z-10 bg-black/30  cursor-pointer backdrop-blur-sm"
          onClick={handleToggleSidebar}
        />
      )}
      <SideNavFrame
        isSidebarOpen={isSidebarOpen}
        compact={compact}
        zIndexClass="z-20"
      >
        <div className="h-full w-full py-[18px] px-3 flex flex-col justify-start gap-3">
          {/* Brand */}
          <BrandLogoBlock
            compact={compact}
            orgName={user?.userOrganisation}
            alt="PaidHR Logo"
            src={
              isPadeDomain()
                ? PadeLogoWhite
                : customizationSettings?.brand?.menuLogoUrl
            }
          />
          {/* Menu */}
          <div className="h-full w-full flex flex-col gap-9">
            {/* Dashboard */}

            <div className="h-full w-full flex flex-col">
              <div className="h-full w-full flex flex-col">
                <div className="h-auto overflow-y-auto w-full flex flex-col gap-0.5">
                  {actions.map((action, index) =>
                    !action.enabled ? (
                      ""
                    ) : (
                      <NavTab
                        action={action}
                        key={index}
                        index={index}
                        toggleSidebar={handleToggleSidebar}
                        compact={compact}
                      />
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </SideNavFrame>
    </>
  )
}
